import { useTranslation } from 'react-i18next';

import TextField from '../../../../../../components/HookFormControls/TextField';
import { i18nNS } from '../../../../../../i18n';
import { TITLE_MAX_CHARACTERS } from '../../PollTitleForm/validators';
import useUnpublishedPollTitle, { UseUnpublishedPollTitle } from './vm';

export interface UnpublishedPollTitleProps extends UseUnpublishedPollTitle {
  className?: string;
}

const UnpublishedPollTitle = ({ className, ...vmProps }: UnpublishedPollTitleProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { formMethods, onSubmit } = vmProps;
  const { handleChange, handleBlur } = useUnpublishedPollTitle(vmProps);

  const { handleSubmit, control } = formMethods;

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)} className={className}>
      <TextField
        control={control}
        name="title"
        characterLimit={TITLE_MAX_CHARACTERS}
        fullWidth
        placeholder={t('untitled_poll', { ns: i18nNS.POLL })}
        hideHelperText
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </form>
  );
};

export default UnpublishedPollTitle;
